export default __webpack_public_path__ + "static/media/fi.91e07c78.svg";